import { useState, useEffect } from "react";
import axios from "axios";
import {
  Modal,
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";
import { useSelector } from "react-redux";
import { fetchTemplate } from "../../../utils/truInkTemplate";
import { ToastContainer, toast } from "react-toastify";
import callPiggybackAPI from "../Helpers/piggyback.api.helper";
function AddTruInkEMMSModal({
  open,
  onClose,
  onConfirm,
  dataRecords,
  savedData,
}) {
  const headers = useSelector((state) => state.header);
  const selectedSite = useSelector((state) => state.truInk.selectedSite);
  const [emmsList, setEmmsList] = useState([]);
  const [name, setName] = useState("");
  const [selectedEmms, setSelectedEmms] = useState(null);
  const [templates, setTemplates] = useState([]);
  const api = localStorage.getItem("api");
  useEffect(() => {
    if (savedData) {
      setName(savedData.name || "");
    }
  }, [savedData]);


  useEffect(() => {
    if (!open) return;
    const api = localStorage.getItem("api");
    axios
      .get(api + `/list/emms`, headers)
      .then((response) => {
        setEmmsList(Array.isArray(response.data) ? response.data : []);
      })
      .catch((error) => {
        console.error("Failed to load EMMS:", error);
        setEmmsList([]);
      });
  }, [open, headers]);

  // Preselect EMMS from savedData when list is loaded
  useEffect(() => {
    if (!savedData || !savedData.emmsId || !emmsList?.length) return;
    const match = emmsList.find((e) => String(e.id) === String(savedData.emmsId));
    if (match) {
      setSelectedEmms(match);
    }
  }, [savedData, emmsList]);

  useEffect(() => {
    // fetch templates for selected EMMS
    const loadTemplates = async () => {
      if (!selectedEmms || !selectedSite) {
        setTemplates([]);
        return;
      }
      try {
        const fetchedTemplateData = await fetchTemplate(selectedSite.tenantId);
        setTemplates(Array.isArray(fetchedTemplateData) ? fetchedTemplateData : []);
      } catch (e) {
        console.error("Failed to load templates:", e);
        setTemplates([]);
      }
    };
    loadTemplates();
  }, [selectedEmms, selectedSite]);



  const handleConfirm = async () => {
    if (!selectedEmms ) {
      toast.error("Please select an EMMS, Busy UI Template, and Free UI Template");
      return;
    }

    try {
      // Save TruInk EMMS first (with the current siteId in the body); it
      // returns the apiId/apiKey to post into globalconfigurations below.
      const truInkEmmsBody = {
        name: name || selectedEmms.name,
        siteId: selectedSite?.id,
        emmsName: selectedEmms.name,
        emmsId: String(selectedEmms.id),
        tenantId: selectedSite.tenantId,
      };

      if (savedData && savedData.id) {
        truInkEmmsBody.id = savedData.id;
      }
      const truInkEmmsResponse = await callPiggybackAPI("truInkEmms", {}, truInkEmmsBody, "POST");
      const { apiId, apiKey } = truInkEmmsResponse || {};

      const basePayload = {
        path: "globalconfigurations",
        query: {},
        emmsId: selectedEmms.id,
        requestType: "POST",
        headers: headers.headers,
      };

      // Only enable truInkConfig on a fresh add, not when editing an existing one.
      if (!(savedData && savedData.id)) {
        const enableConfigPayload = {
          ...basePayload,
          body: { key: "truInkConfig", values: ["true"] },
        };
        await axios.post(api + `/emms/piggyback`, enableConfigPayload, headers);
      }


      toast.success(savedData ? "TruInk EMMS updated successfully" : "Configuration and TruInk EMMS saved");
      handleClose();
      if (onConfirm) onConfirm();
    } catch (error) {
      console.error("Failed to save configuration:", error);
      toast.error("Failed to save configuration");
    }

  };

  const handleClose = () => {
    setName("");
    setSelectedEmms(null);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: "8px",
          boxShadow: 24,
          p: 3,
          width: 500,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography variant="h6" gutterBottom>
          {savedData ? "Edit TruInk EMMS" : "Add TruInk EMMS"}
        </Typography>
        <TextField
          fullWidth
          label="TruInk EMMS Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <Select
          fullWidth
          value={selectedEmms || ""}
          onChange={(e) => {  setSelectedEmms(e.target.value); }}
          displayEmpty
          renderValue={(selected) => {
            if (!selected) {
              return <em>Select EMMS</em>;
            }
            return selected.name;
          }}
        >
          {emmsList?.map((emmsItem) => (
            <MenuItem key={emmsItem.id} value={emmsItem}>
              {emmsItem.name}
            </MenuItem>
          ))}
        </Select>

       
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              borderRadius: "4px",
              textTransform: "none",
              fontWeight: "bold",
              background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
              color: "#fff",
              boxShadow: "none",
              "&:hover": {
                background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                opacity: 0.95,
                boxShadow: "none",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            disableElevation
            disabled={!name.trim()}
            sx={{
              borderRadius: "4px",
              textTransform: "none",
              fontWeight: "bold",
              backgroundColor: "rgb(90, 28, 47)",
              "&:hover": { backgroundColor: "rgb(70, 20, 35)" },
              "&.Mui-disabled": { backgroundColor: "rgba(90, 28, 47, 0.4)", color: "#fff" },
            }}
          >
            Confirm
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default AddTruInkEMMSModal;
